import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RJSFSchema } from "@rjsf/utils";
import { IChangeEvent } from "@rjsf/core";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store/store";
import { selectOpenedForm, toggleForm } from "../../store/formSlice";
import {
    convertJsonSchemaPropertiesForPrefixSearch,
    getFieldsWithoutHidden,
    hideDateFields,
    updateFiledsWithIntegerType
} from "./searchform-helpers";
import { SearchJsonForm } from "../../ui/form/SearchJsonForm";
import { CombinedProfileAndJsonSchema } from "../../repository/models_v2";


interface SearchFormProps {
    formData?: CombinedProfileAndJsonSchema,
}

export const SearchForm = ({ formData }: SearchFormProps) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
    const opened = useTypedSelector(selectOpenedForm)
    const [values, setValues] = useState<IChangeEvent>()
    const location = useLocation()

    // FIX ME - temporary update of data until we have "date" format of data from backend
    const prefixSearchSwapoutForm = convertJsonSchemaPropertiesForPrefixSearch(formData)
    const withoutIntegerForm = updateFiledsWithIntegerType(prefixSearchSwapoutForm?.jsonschema)
    const withoutDateFieldsForm = hideDateFields(withoutIntegerForm)
    const fieldsWithoutHidden = getFieldsWithoutHidden(withoutDateFieldsForm) as RJSFSchema | null

    const handleChange = (data: IChangeEvent) => {
        setValues(data)
    }

    const onSubmit= () => {
        if(!!values?.formData){
            const isValues = !!Object.values(values?.formData).filter(item => !!item).length

            if(isValues){

                const urlSearchParamsInput =
                    Object.fromEntries(
                        Object.entries(values.formData)
                            .filter( ([_k, v]) => !!v ) // Filter out any props without values
                            .map( ([_k, v]) => {
                                const prefixSearchParam = formData?.jsonhal?._templates?.["search"]?.["properties"]?.find( (searchableProperty) => searchableProperty.name === _k+'~prefix');
                                if (prefixSearchParam) {
                                    return [_k+'~prefix', v];
                                } else {
                                    return [_k, v];
                                }
                            })
                    )

                const params = new URLSearchParams(urlSearchParamsInput)
                const searchParams = params.toString()

                navigate(`search?${searchParams}`)
                return
            }
        }
        navigate('search')
    }

    useEffect(() => {
        if(!!location.search){
            const params = new URLSearchParams(location.search)
            const entries = [...params.entries()]
            const obj = entries.reduce((o, [key, value]) => ({ ...o, [key]: value}), {})
            const updatedObj: {[k: string]: string} = { ...obj }

            setValues({ formData: updatedObj } as IChangeEvent)
            return
        }
        setValues({} as IChangeEvent)
    },[location, setValues])

    /* [RGFNLSLA-860] rjsf/mui uses JSONSchema to generate the forms, so we maintain a jsonschema for the current
    * entity type in the state parallel to the relevant HAL data. */
    return (
        <SearchJsonForm
            opened={opened}
            onCollapseButtonClick={() => dispatch(toggleForm(!opened))}
            schema={fieldsWithoutHidden}
            formData={values?.formData}
            onSubmit={onSubmit}
            onChange={handleChange}
        />
    )
}
